import Box from '@mui/material/Box';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import MyProductItem from './MyProductItem';
import {
  AccountUser,
  isTestOpsFeature, isTestOpsPlatformFeature,
  OrganizationFeature,
  TestOpsSubscriptionSource,
} from '../../models';
import { DEFAULT_EXECUTIONS } from '../home/utils';

const useStyles = makeStyles(theme => ({
  boxColumn: {
    display: 'column',
    gap: theme.spacing(1, 2.5),
  },
  boxFlex: {
    display: 'flex',
    gap: theme.spacing(2, 2),
    flexWrap: 'wrap',
  },
  subTitle: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
    color: '#233145',
  },
}));

export interface ProductItem {
  id: number;
  feature: OrganizationFeature;
  quota?: number;
  source?: TestOpsSubscriptionSource;
  numberProject?: number;
  expiryDate?: Date;
}

export interface ProductsProps {
  organizationId: number;
  products: ProductItem[];
  numberProjects?: number;
  domain?: string;
  accountUser?: AccountUser;
}

const MyProductInfo = (props: ProductsProps) => {
  const classes = useStyles();
  const { organizationId, products, numberProjects, domain, accountUser } = props;

  let productItems = products;
  const testOpsPlatformSubscription = products
    .filter(product => isTestOpsPlatformFeature(product.feature))[0];
  // check and hide old TO when have TO Platform subscription
  if (testOpsPlatformSubscription) {
    productItems = productItems.filter(product => !isTestOpsFeature(product.feature));
  }
  const hasTestOpsSubscription = products
    .filter(product => isTestOpsFeature(product.feature)).length > 0;
  if (!testOpsPlatformSubscription && !hasTestOpsSubscription) {
    productItems.push({
      id: 0,
      feature: OrganizationFeature.TESTOPS_PLATFORM,
      quota: DEFAULT_EXECUTIONS,
      numberProject: numberProjects,
    });
  }

  const recorder: ProductItem = {
    id: 0,
    feature: OrganizationFeature.RECORDER,
  };

  return (
    <Box className={classes.boxColumn}>
      <Typography ml={0.5} variant="subtitle2" className={classes.subTitle}>
        <FormattedMessage id="admin.home.my.katalon.products" />
      </Typography>
      <Box className={classes.boxFlex}>
        {productItems.map(product => (
          <MyProductItem
            domain={domain}
            key={`${product.id}${product.feature}`}
            organizationId={organizationId}
            product={product}
            accountUser={accountUser}
          />
        ))}
        <MyProductItem
          key={recorder.id}
          organizationId={organizationId}
          product={recorder}
        />
      </Box>
    </Box>
  );
};

export default MyProductInfo;
